import MarketingImage from '@/components/landing/MarketingImage';
import React from 'react';
import { Link } from 'react-router-dom';
import { blogSeoMetadata as blogPosts } from '@/data/blogSeoMetadata';
import styles from './BlogInsightsSection.module.css';

const BlogInsightsSection = () => {
  return (
    <section id="blogs" className={styles.section}>
      <div className={styles.blogContainer}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>• BLOG</p>
          <h2 className={styles.title}>Latest Insights</h2>
          <p className={styles.subtitle}>
            Research updates and data-driven perspectives shaping the future
            of nutrition management.
          </p>
        </div>

        <div className={styles.postGrid}>
          {blogPosts.map(post => (
            <Link key={post.slug} to={post.href} className={styles.postLink}>
              <article className={styles.postCard}>
                <div className={styles.imageWrap}>
                  <MarketingImage src={post.imagePath} alt={post.imageAlt ?? post.title} loading="lazy" />
                </div>
                <div className={styles.metaRow}>
                  <span className={styles.category}>{post.category}</span>
                  <span className={styles.date}>{post.displayDate}</span>
                </div>
                <h3 className={styles.postTitle}>{post.title}</h3>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogInsightsSection;
